import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>music-note-eighth</title><path d="M12 3V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17S7.79 21 10 21 14 19.21 14 17V7H18V3H12Z" /></svg>

const Quaver = () => {

    return (
        <SvgIcon titleAccess='Timing'>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns: xlink="http://www.w3.org/1999/xlink"
            >
                <path d="M12 3V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17S7.79 21 10 21 14 19.21 14 17V7H18V3H12Z" />
            </svg>

        </SvgIcon>
    );
};

export default Quaver;
